import Button from "components/Button";
import { Loader } from "components/Loader/Loader.component";
import Text from "components/Text";
import { FC } from "react";
import { TbFileText } from "react-icons/tb";
import theme from "theme";
import HighLight from "./HighLight";
import { InfoTabs } from "./InfoTabs/InfoTabs";
import {
    CustomUrlButtonSection,
    CustomUrlSection,
    FlexContainer,
    LeftSection,
    ProfileInnerWrapper,
    ProfileWrapper,
    ResourcesItem,
    ResourcesList,
    ResourcesSection,
    RightSection,
} from "./Profile.styled";
import ProfileStrength from "./ProfileStrength";
import { useProfile } from "./useProfile";

export const Profile: FC = () => {
    const { isLoading } = useProfile();

    if (isLoading) {
        return (
            <ProfileWrapper>
                <Loader size={28} />
            </ProfileWrapper>
        );
    }

    return (
        <ProfileWrapper>
            <ProfileInnerWrapper>
                <Text variant="heading5" fontWeight="700">
                    My Profile
                </Text>
                <FlexContainer>
                    <LeftSection>
                        <HighLight />
                        <ProfileStrength />
                        <InfoTabs />
                    </LeftSection>
                    <RightSection>
                        <CustomUrlSection>
                            <Text variant="body2" fontWeight="600" color="#fff">
                                Want a custom URL for your profile?
                            </Text>
                            <Text variant="label" color="#8a8a8a">
                                Eveniet porro non aut exercitationem aspernatur
                                porro blanditiis consequatur dignissimos.
                            </Text>
                            <CustomUrlButtonSection>
                                <Button
                                    type="button"
                                    variant="filled"
                                    fullWidth
                                >
                                    Upgrade Now
                                </Button>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    fullWidth
                                >
                                    Edit Now
                                </Button>
                            </CustomUrlButtonSection>
                        </CustomUrlSection>
                        <ResourcesSection>
                            <Text variant="label">Resources</Text>
                            <Text
                                variant="label"
                                color={theme.colors.grey.secondary}
                            >
                                Tips on building a professional model profile
                                that will help you get noticed.
                            </Text>
                            <ResourcesList>
                                <ResourcesItem>
                                    <TbFileText fontSize="20px" />
                                    <Text variant="label">
                                        tempore voluptas ducimus plac eat. Sit
                                        eos
                                    </Text>
                                </ResourcesItem>
                                <ResourcesItem>
                                    <TbFileText fontSize="20px" />
                                    <Text variant="label">
                                        tempore voluptas ducimus plac eat. Sit
                                        eos
                                    </Text>
                                </ResourcesItem>
                                <ResourcesItem>
                                    <TbFileText fontSize="20px" />
                                    <Text variant="label">
                                        tempore voluptas ducimus plac eat. Sit
                                        eos
                                    </Text>
                                </ResourcesItem>
                            </ResourcesList>
                        </ResourcesSection>
                    </RightSection>
                </FlexContainer>
            </ProfileInnerWrapper>
        </ProfileWrapper>
    );
};
